module.exports = __webpack_public_path__ + "media/Audio18_g.098f2bb8.wav";